// src/contexts/WalletCashbackContext.tsx
import React, { createContext, useContext, useEffect, useState, ReactNode } from 'react'
import api from '../api/client'

// ================= TYPES =================
export interface Wallet {
  id: number
  balance: string
  locked_amount: string
  available_balance: string
}

export interface Cashback {
  id: number
  amount: string
  expires_at: string
  used: boolean
  note?: string
  created_at: string
  order: number
}

interface WalletCashbackContextType {
  wallet: Wallet | null
  cashbackList: Cashback[]
  loading: boolean
  refreshWallet: () => void
  refreshCashback: () => void
}

// ============== CONTEXT INIT ==============
const WalletCashbackContext = createContext<WalletCashbackContextType | undefined>(undefined)

export const useWalletCashback = (): WalletCashbackContextType => {
  const context = useContext(WalletCashbackContext)
  if (!context) throw new Error('useWalletCashback must be used within WalletCashbackProvider')
  return context
}

// ============== PROVIDER ==============
export const WalletCashbackProvider = ({ children }: { children: ReactNode }) => {
  const [wallet, setWallet] = useState<Wallet | null>(null)
  const [cashbackList, setCashbackList] = useState<Cashback[]>([])
  const [loading, setLoading] = useState<boolean>(true)

  const refreshWallet = async () => {
    try {
      const res = await api.get<Wallet>('/my/')
      setWallet(res.data)
    } catch (err) {
      console.error('Error fetching wallet:', err)
    }
  }

  const refreshCashback = async () => {
    try {
      const res = await api.get<{results:Cashback[]}>('/cashbacks/')
      setCashbackList(res.data.results)
      setLoading(false)
    } catch (err) {
      console.error('Error fetching cashback:', err)
    }
  }



  return (
    <WalletCashbackContext.Provider value={{ wallet, cashbackList, loading, refreshWallet, refreshCashback }}>
      {children}
    </WalletCashbackContext.Provider>
  )
}
